import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { getUserHistory } from '../api/historyApi';
import './RecFloatingBadge.css';

const TEXT = ' ✦   כנסי להמליץ וקבלי קופון הנחה!    ✦  ';

const RecFloatingBadge = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) { setShow(false); return; }
    getUserHistory(user.id)
      .then(history => {
        const pending = (history || []).flatMap(p => p.items || []).filter(item => {
          const s = item.recommendation_status;
          return !s || s === 'none' || s === 'אין המלצה' || s === 'not_recommended';
        });
        setShow(pending.length > 1);
      })
      .catch(() => setShow(false));
  }, [user]);

  if (!show) return null;

  const size = 200;
  const cx = size / 2;
  const cy = size / 2;
  const outerR = 96;      // מסגרת חיצונית
  const textR  = 78;      // מסלול הטקסט
  const innerR = 66;      // מסגרת פנימית
  const fillR  = 96;      // רקע צהוב

  // כוכב 5 קצוות עם קצוות עגולים — path יחסי למרכז
  const starPath = (() => {
    const points = 5;
    const outerStar = 28;
    const innerStar = 12;
    const path = [];
    for (let i = 0; i < points * 2; i++) {
      const angle = (i * Math.PI) / points - Math.PI / 2;
      const r = i % 2 === 0 ? outerStar : innerStar;
      const x = cx + r * Math.cos(angle);
      const y = cy + r * Math.sin(angle);
      path.push(i === 0 ? `M ${x},${y}` : `L ${x},${y}`);
    }
    path.push('Z');
    return path.join(' ');
  })();

  return (
    <div className="rec-float-wrap" onClick={() => navigate('/profile/history')}>
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} className="rec-float-svg">
        <defs>
          {/* מסלול טקסט עליון */}
          <path
            id="rf-top"
            d={`M ${cx - textR},${cy} A ${textR},${textR} 0 0,1 ${cx + textR},${cy}`}
          />
          {/* מסלול טקסט תחתון */}
          <path
            id="rf-bot"
            d={`M ${cx + textR},${cy} A ${textR},${textR} 0 0,1 ${cx - textR},${cy}`}
          />
          {/* clipPath לכוכב — חור בצורת כוכב */}
          <clipPath id="star-hole">
            {/* מלבן שמכסה הכל */}
            <path fillRule="evenodd" d={`M 0,0 H ${size} V ${size} H 0 Z ${starPath}`} />
          </clipPath>
        </defs>

        {/* רקע צהוב */}
        <circle cx={cx} cy={cy} r={fillR} fill="#FDE586" />

        {/* מסגרת חיצונית */}
        <circle cx={cx} cy={cy} r={outerR} fill="none" stroke="#000" strokeWidth="1.5" />

        {/* מסגרת פנימית */}
        <circle cx={cx} cy={cy} r={innerR} fill="none" stroke="#000" strokeWidth="1.2" />

        {/* טקסט עליון */}
        <text className="rec-float-text">
          <textPath href="#rf-top" startOffset="50%" textAnchor="middle">{TEXT}</textPath>
        </text>

        {/* טקסט תחתון */}
        <text className="rec-float-text">
          <textPath href="#rf-bot" startOffset="50%" textAnchor="middle">{TEXT}</textPath>
        </text>

        {/* "חור" כוכב — שכבת צהוב עם clip שמשאיר רק את הכוכב חשוף לרקע */}
        <circle
          cx={cx} cy={cy} r={innerR - 2}
          fill="#FDE586"
          clipPath="url(#star-hole)"
        />
        {/* קו מתאר לכוכב עם קצוות עגולים */}
        <path
          d={starPath}
          fill="none"
          stroke="#000"
          strokeWidth="1.4"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default RecFloatingBadge;
